export default __webpack_public_path__ + "static/media/iPadSS3.b0ddd432.png";